import moment from 'moment/moment';

export default {
  data() {
    return {
      showItem: null,
      editItem: null,
      searchActualName: '',
      searchArchiveName: '',
      searchMyName: '',
      seminarsType: 0,
      showDialog: false,
      aboutSeminar: false,
      files: [],
      documents: [],
      valid: false,
      maxFileSize: 5, // Mbt
      maxFilesLength: 15,
      minFilesLength: 4,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        maxFiles: () => this.files.length < this.maxFilesLength
          || `Количество файлов не более ${this.maxFilesLength}`,
        minFiles: () => this.files.length >= this.minFilesLength
          || `Количество файлов не менее ${this.minFilesLength}`,
      },
    };
  },
  computed: {
    actual() {
      return this.$store.state.seminars.actual;
    },
    filterActual() {
      return this.actual
        .filter(item => (item.city ?? '').toLowerCase().includes(this.searchActualName.toLowerCase()));
    },
    archive() {
      return this.$store.state.seminars.archive;
    },
    my() {
      return [
        ...this.actual.filter(el => el.visit),
        ...this.archive.filter(el => el.visit),
      ];
    },
    filterMy() {
      return this.my
        .filter(item => (item.city ?? '').toLowerCase().includes(this.searchMyName.toLowerCase()));
    },
    filterArchive() {
      return this.archive
        .filter(item => (item.city ?? '').toLowerCase().includes(this.searchArchiveName.toLowerCase()));
    },
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.$store.dispatch('SetTitle', 'Семинары');
    this.$store.dispatch('seminars/GetList', {
      profile_id: this.user.profile_id,
    });
  },
  methods: {
    showSeminar(item) {
      this.showItem = item;
      this.aboutSeminar = true;
    },
    approveSeminar(item) {
      this.editItem = item.visit;
      this.showDialog = true;
    },
    isEditable(item) {
      const date = moment(item.date_event);
      const yesterday = moment().add(-1, 'days');
      return item.is_subscribe && yesterday < date;
    },
    Subscribe(item) {
      this.$store
        .dispatch('seminars/Subscribe', {
          profile_id: this.user.profile_id,
          seminar_id: item.id,
        })
        .then(() => {
          this.$store.dispatch('seminars/GetList', {
            profile_id: this.user.profile_id,
          });
        });
    },
    goToTest(item) {
      this.$store.dispatch('seminars/SetForTest', item);

      this.$router.push({
        path: `/test/${item.test.id}`,
        query: { from: 'seminars' },
      });
    },
    goToTestResult(item) {
      this.$router.push({
        path: `/results/${item.test.id}`,
        query: { from: 'seminars' },
      });
    },
    Unsubscribe(item) {
      const app = this;
      app.$store
        .dispatch('seminars/Unsubscribe', {
          profile_id: this.user.profile_id,
          seminar_id: item.id,
        })
        .then(() => {
          app.$store.dispatch('seminars/GetList', {
            profile_id: this.user.profile_id,
          });
        }).catch((error) => {
          this.$store.dispatch('HandleError', error);
        });
    },
    deleteImage(idx) {
      this.editItem.photo.splice(idx, 1);
    },
    pluralizePlace(count) {
      if (count % 10 === 1 && count % 100 !== 11) {
        return ` (${count} место)`;
      }
      if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) {
        return ` (${count} места)`;
      }

      return ` (${count} мест)`;
    },
    /** Методы для работы с документами */
    async TransformFile(files, idx) {
      const app = this;
      const file = files[0];
      const document = { file: '', url: '', name: '' };
      if (!file || file.name.lastIndexOf('.') <= 0) {
        return document;
      }
      const fr = new FileReader();
      await fr.readAsDataURL(file);
      await fr.addEventListener('load', () => {
        document.name = file.name;
        document.file = null;
        document.base64 = fr.result;
        document.key = `${idx}_${Date.now()}`;
        app.editItem.photo.push(document);
      });
      return document;
    },
    Approved() {
      this.$store.getters.axl
        .post('/seminars/api/seminars/update-visit', { ...this.editItem })
        .then(() => {
          this.$store.dispatch('seminars/GetList', {
            profile_id: this.user.profile_id,
          });
          this.editItem = null;
          this.showDialog = false;
        })
        .catch((error) => {
          this.$store.dispatch('HandleError', error);
        });
    },
  },
};
